export const ru = {
    campaign: 'Кампания',
    name: 'Название',
    status: 'Статус',
    type: 'Тип'
};
